import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({ baseURL: API, timeout: 10000 });

// ---------- Public reads ----------

export const fetchCategories = async () => {
  const response = await apiClient.get('/categories');
  return response.data.categories;
};

export const fetchProducts = async (category = null) => {
  const params = category ? { category } : {};
  const response = await apiClient.get('/products', { params });
  return response.data.products;
};

export const fetchProduct = async (id) => {
  const response = await apiClient.get(`/products/${id}`);
  return response.data;
};

export const fetchReviews = async () => {
  const response = await apiClient.get('/reviews');
  return response.data.reviews;
};

export const fetchStoreInfo = async () => {
  const response = await apiClient.get('/store-info');
  return response.data;
};

export const fetchSiteMedia = async () => {
  const response = await apiClient.get('/site-media');
  return response.data || {};
};

export const fetchPageTexts = async () => {
  const response = await apiClient.get('/page-texts');
  return response.data || { tr: {}, en: {}, flat: {} };
};

// ---------- Admin (Bearer-token) ----------

const authHeaders = () => {
  const token = localStorage.getItem('admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const adminLogin = async (email, password) => {
  const response = await apiClient.post('/auth/login', { email, password });
  return response.data;
};

export const adminMe = async () => {
  const response = await apiClient.get('/auth/me', { headers: authHeaders() });
  return response.data;
};

export const adminUploadFile = async (file, folder = 'misc') => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('folder', folder);
  const response = await apiClient.post('/admin/upload', fd, {
    headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const adminSetSiteMedia = async (key, url) => {
  const response = await apiClient.put(`/admin/site-media/${key}`, { url }, { headers: authHeaders() });
  return response.data;
};

export const adminUpdateCategory = async (id, payload) => {
  const response = await apiClient.put(`/admin/categories/${id}`, payload, { headers: authHeaders() });
  return response.data;
};

export const adminUpdateProduct = async (id, payload) => {
  const response = await apiClient.put(`/admin/products/${id}`, payload, { headers: authHeaders() });
  return response.data;
};

export const adminUpdateStoreInfo = async (payload) => {
  const response = await apiClient.put('/admin/store-info', payload, { headers: authHeaders() });
  return response.data;
};

export const adminUploadLogo = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const response = await apiClient.post('/admin/logo', fd, {
    headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const adminUpdatePageTexts = async (updates) => {
  const response = await apiClient.put('/admin/page-texts', { updates }, { headers: authHeaders() });
  return response.data;
};
